import React, { useState } from 'react';import { Button, useCreate, useNotify, useRefresh, useTranslate, Confirm } from 'react-admin';import { Grid } from '@material-ui/core';import { makeStyles } from '@material-ui/core/styles';

import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import IconSave from '@material-ui/icons/Save';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';


import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';


import { apiUrl } from './../common/constants';import { headersAPIObjectAuth } from './../common/utils';

export const DocsCameraButton = ({ target, items_id , label, icon, topToolbar, ...props }) => {

    const [showDialog, setShowDialog] = useState(false);
    const [create, { loading }] = useCreate('docs');
    const notify = useNotify();
    const refresh = useRefresh();    
    const translate = useTranslate();  
    const classes = useStylesWebcam(props);

    let labelButton = label;
    let iconButton = icon ? icon : <IconContentAdd/>;

    const handleClick = () => {
        setShowDialog(true);
        setTimeout( videoStart , 100);
    };

    const handleCloseClick = () => {
        stopVideo();
        setShowDialog(false);
    };

    const handleSubmit = async values => {
        create(
            { payload: { data: values } },
            {
                onSuccess: ({ data }) => {
                    setShowDialog(false);
                    refresh();
                },
                onFailure: error => {
                    notify(translate('ra.auth.error_network'), 'error');
                }
            }
        );
    };

    // WEBCAM
    var video = document.querySelector("#video");  

    function videoStart()
    {
        video = document.querySelector("#video");  
  
        // Basic settings for the video to get from Webcam  
        const constraints = {  
            audio: false,  
            video: {  
                width: 200 , height: 200  
            }  
        };  
      
        // This condition will ask permission to user for Webcam access  
        if (navigator.mediaDevices.getUserMedia) {  
            navigator.mediaDevices.getUserMedia(constraints)  
                .then(function (stream) {  
                    video.srcObject = stream;  
                })  
                .catch(function (error) {  
                    console.log(error);

                    notify( translate('docs.webcam_error') ,'error'); 
                    setShowDialog(false);
                });  
        }  
    }    
  
    function stopVideo() {  
        video = document.querySelector("#video"); 
        var stream = video.srcObject;  
        var tracks = stream.getTracks();  
  
        for (var i = 0; i < tracks.length; i++) {  
            var track = tracks[i];  
            track.stop();  
        }  
        video.srcObject = null;  
    }  

    const handleClickCapture = () => {
        var canvas = document.getElementById('canvas');  
        var context = canvas.getContext('2d');  
  
        video = document.querySelector("#video");  
        context.drawImage(video, 0, 0);
    };

    const handleClickSave = () => {

        var destinationCanvas = document.createElement("canvas");  
        var destCtx = destinationCanvas.getContext('2d');  

        var canvas = document.getElementById("canvas");
        var img    = canvas.toDataURL("image/png");

        img = img.replace('data:image/png;base64,', '');  

        const data = { associations_id : localStorage.getItem('associations_id'), target: target, items_id: items_id, content: img };
        
        fetch(apiUrl + '/docs/photo', {
            method: 'POST',
            headers: headersAPIObjectAuth(),
            body: JSON.stringify(data)
        })
        .then(response => {
            if (!response.ok) {
                // Forcem que entri al catch
                throw new Error('HTTP_ERROR_' + response.status);
            }
            return response;
        })
        .then(() => {
            stopVideo();
            setShowDialog(false);
            refresh();
        })
        .catch(e => {
            console.error(e);
            notify(translate('ra.auth.error_network'), 'error');
        })
        .finally(() => {
        });

    };

    return (
        <>
            <Button onClick={handleClick} label={labelButton} className="btnPhotoUser btnWebcam">
               {iconButton}
            </Button>

            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label={translate('docs.webcam')}
            >
                <DialogTitle>{translate('docs.webcam')}</DialogTitle>


                <Grid container spacing={0}>

                    <Grid item xs={6} className="gridWebCam"> 
                        <center><video id="video" playsInline autoPlay className="webCamCapture1" width="200" height="200"></video> 
                        <br/><Button label={translate('docs.webcam_capture')} onClick={handleClickCapture} >
                            <PhotoCameraIcon />
                        </Button></center>
                    </Grid> 

                    <Grid item xs={6} className="gridWebCam"> 
                        <center>
                        <canvas id="canvas" className="webCamCapture2"  width="200" height="200"></canvas> 
                        </center>
                    </Grid> 

                </Grid>

                <DialogActions>
                    <Button label="ra.action.cancel" onClick={handleCloseClick} >
                        <IconCancel />
                    </Button>
                    <Button label={translate('ra.action.save')} onClick={handleClickSave} variant="contained">
                        <IconSave />
                    </Button>
                    <a id="linkImage"></a>
                </DialogActions>

            </Dialog>
        </>
    );
}

const useStylesWebcam = makeStyles(theme => ({
    card: {
        minHeight: 52,
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        '& a': {
            textDecoration: 'none',
            color: 'inherit',
        },
        marginBottom: 20
    },
    main: (props: Props) => ({
        overflow: 'inherit',
        padding: 16,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'right',
        '& .icon': {
            color: theme.palette.type === 'dark' ? 'inherit' : '#FF6600',
        },
    }),
    title: {},
}));



export const DocsDeleteButton = ({ target, items_id , label, icon, topToolbar, onSuccess, ...props }) => {

    const [open, setOpen] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [create, { loading }] = useCreate('docs');
    const notify = useNotify();
    const refresh = useRefresh();    
    const translate = useTranslate();  
    const classes = useStylesWebcam(props);

    let labelButton = label;
    let iconButton = icon ? icon : <IconContentAdd/>;
    
    const deletePhoto = () => {

        fetch(apiUrl + '/docs/photo?items_id='+items_id+'&target='+target, { method: 'DELETE', headers: headersAPIObjectAuth() })
            .then(() => {
                setShowDialog(false);
                refresh();
                if (onSuccess) onSuccess();
            })
            .catch((e) => {
            })
            .finally(() => {
            });
    };
    
    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);

    const handleConfirm = () => {
        deletePhoto();
        setOpen(false);
    };

    return (
        <>
            <Button onClick={handleClick} label={labelButton} className="btnPhotoUser btnDeletePhoto">
               {iconButton}
            </Button>

            <Confirm
                isOpen={open}
                loading={loading}
                title={translate('docs.delete_photo_title')}
                content={translate('docs.delete_photo_ask')}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />

        </>
    );
}